export const modalStyle = {
	content: {
        position: "fixed",
		top: "50%",
		left: "50%",
		width: "clamp(300px, 90%, 600px)",
		height: 'clamp(300px, 70vh, 600px)',
		transform: "translate(-50%, -50%)",
	},
    overlay: {
        width: "100vw",
        height: "100%",
        position: "fixed",
    }
};